module.exports = __webpack_public_path__ + "img/piclist-icon.1438f3cd.svg";